import { defineStore } from 'pinia';

export const useTableDialogStore = defineStore('tableDialog', {
	state: () => ({
		open: false,
		headers: [] as string[],
		rows: [] as { label: string; values: string[] }[],
		highlight: '' as string,
		arrangement: 'byColumn' as 'byColumn' | 'byRow',
	}),
	actions: {
		show(headers: string[], rows: { label: string; values: string[] }[], highlight: string = '', arrangement: 'byColumn' | 'byRow' = 'byColumn') {
			this.headers = headers;
			this.rows = rows;
			this.highlight = highlight;
			this.arrangement = arrangement;
			this.open = true;
		},
		close() {
			this.open = false;
		},
	},
});
